import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Layouts
import MainLayout from './components/layout/MainLayout';
import AuthLayout from './components/layout/AuthLayout';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tasks from './pages/Tasks';
import TaskDetail from './pages/TaskDetail';
import Organizations from './pages/Organizations';
import Reports from './pages/Reports';
import KPI from './pages/KPI';
import WorkPlans from './pages/WorkPlans';
import Chat from './pages/Chat';
import Notifications from './pages/Notifications';
import Monitoring from './pages/Monitoring';
import Documents from './pages/Documents';
import Risks from './pages/Risks';
import Archive from './pages/Archive';
import Settings from './pages/Settings';
import Users from './pages/Users';

// Protected Route wrapper
const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// Admin Route wrapper
const AdminRoute = ({ children }) => {
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  if (user?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Routes>
      {/* Auth routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
      </Route>

      {/* Protected routes */}
      <Route
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/tasks/:id" element={<TaskDetail />} />
        <Route path="/organizations" element={<Organizations />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/kpi" element={<KPI />} />
        <Route path="/workplans" element={<WorkPlans />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/monitoring" element={<Monitoring />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/risks" element={<Risks />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/settings" element={<Settings />} />

        {/* Admin only routes */}
        <Route
          path="/users"
          element={
            <AdminRoute>
              <Users />
            </AdminRoute>
          }
        />
      </Route>

      {/* 404 */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
